import { SESSION_STATUS } from "../constants";

export function isUploadSessionEditable(session) {
  return (
    session.status !== SESSION_STATUS.Synchronized &&
    session.status !== SESSION_STATUS.Completed
  );
}
